<template>
	<PackageIcon v-if="iconAvailable" :class="mergedClass" />
</template>

<script lang="ts" setup>
import { IconLoader } from '@thermenresorts/icons';
import { twMerge as tw, type ClassNameValue } from 'tailwind-merge';
import { computed, defineComponent, useAttrs } from 'vue';

const attrs = useAttrs();

const props = defineProps<{
  name?: string | null
}>();

const EmptyComponent = defineComponent({
  name: 'EmptyComponent',
  template: '<template />',
});

const loader = new IconLoader();

const PackageIcon = computed(() => props.name
  ? (loader.getSvg(props.name) || EmptyComponent)
  : EmptyComponent);

const iconAvailable = computed(() => !! loader.getSvg(props.name));

const mergedClass = computed(() => tw(
  ['size-4 flex-none', props.name],
  attrs.class as ClassNameValue,
));
</script>
